import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

function KelolaDokumenPerencanaan({ setToken }) {
  const [dokumen, setDokumen] = useState([]);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertJudul, setAlertJudul] = useState(false);
  const [alertDeskripsi, setAlertDeskripsi] = useState(false);
  const [alertLink, setAlertLink] = useState(false);
  const [formData, setFormData] = useState({
    judul: "",
    deskripsi: "",
    link: "",
    created_at: "",
  });
  const [id, setId] = useState("");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      await fetch(BaseURL + "index.php/api/Dokumen_perencanaan")
        .then((res) => res.json())
        .then((data) => {
          if (data.data) {
            let tableData = [];
            for (let i = 0; i < data.data.length; i++) {
              tableData.push({
                judul: data.data[i].judul,
                deskripsi: data.data[i].deskripsi,
                link: data.data[i].link,
                tanggal_post: data.data[i].created_at,
                user: data.data[i].nama_user,
                opsi: data.data[i].id_dok_perencanaan,
              });
            }
            setDokumen(tableData);
          }
          setLoading(false);
        });
    };
    getData();
  }, [load]);

  const columns = [
    {
      name: "judul",
      label: "Judul",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "deskripsi",
      label: "Deskripsi",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "link",
      label: "Link",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ flex: 1 }}>
              <a href={value} target="_blank" rel="noopener noreferrer">
                {value}
              </a>
            </div>
          );
        },
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "user",
      label: "Admin",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                className="tooltip btn-hapus-row"
                onClick={() => hapus(value)}
              >
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  let tablesData = [];

  if (dokumen) {
    for (let i = 0; i < dokumen.length; i++) {
      tablesData.push({
        judul: dokumen[i].judul,
        deskripsi: dokumen[i].deskripsi,
        link: dokumen[i].link,
        tanggal_post: dokumen[i].created_at,
        user: dokumen[i].nama_user,
        opsi: dokumen[i].id_dok_perencanaan,
      });
    }
  }

  const tambah = () => {
    if (formData.judul == "") {
      setAlertJudul(true);
    } else {
      setAlertJudul(false);
    }

    if (formData.deskripsi == "") {
      setAlertDeskripsi(true);
    } else {
      setAlertDeskripsi(false);
    }

    if (formData.link == "") {
      setAlertLink(true);
    } else {
      setAlertLink(false);
    }

    if (
      formData.judul !== "" &&
      formData.deskripsi !== "" &&
      formData.link !== ""
    ) {
      const data = new FormData();
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      data.append("request", "post");
      data.append("judul", formData.judul);
      data.append("deskripsi", formData.deskripsi);
      data.append("link", formData.link);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_at", date);

      try {
        fetch(BaseURL + "index.php/api/dokumen_perencanaan", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              deskripsi: "",
              link: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = (id) => {
    var encodedKey = encodeURIComponent("id_dok_perencanaan");
    var encodedValue = encodeURIComponent(id);
    const formBody = [encodedKey + "=" + encodedValue];
    try {
      fetch(BaseURL + "index.php/api/dokumen_perencanaan", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = (id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/dokumen_perencanaan?id=" + id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            ...formData,
            judul: data.data[0].judul,
            deskripsi: data.data[0].deskripsi,
            link: data.data[0].link,
          });
          setId(id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.judul == "") {
      setAlertJudul(true);
    } else {
      setAlertJudul(false);
    }

    if (formData.deskripsi == "") {
      setAlertDeskripsi(true);
    } else {
      setAlertDeskripsi(false);
    }

    if (formData.link == "") {
      setAlertLink(true);
    } else {
      setAlertLink(false);
    }

    if (
      formData.judul !== "" &&
      formData.deskripsi !== "" &&
      formData.link !== ""
    ) {
      const data = new FormData();
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      data.append("request", "put");
      data.append("id_dok_perencanaan", id);
      data.append("judul", formData.judul);
      data.append("deskripsi", formData.deskripsi);
      data.append("link", formData.link);
      data.append("id_user", localStorage.getItem("id"));
      data.append("updated_at", date);

      try {
        fetch(BaseURL + "index.php/api/dokumen_perencanaan", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              deskripsi: "",
              link: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin
        title="Kelola Dokumen Perencanaan"
        setToken={(e) => setToken(e)}
      />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable
              title={"Daftar Dokumen"}
              data={dokumen}
              columns={columns}
              options={options}
              download={false}
              className="table"
            />
          )}
        </div>
      </div>

      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField
              id="judul"
              label="Judul"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, judul: e.target.value })
              }
              value={formData.judul}
            />
            {alertJudul && (
              <div className="danger-alert">Nama judul tidak boleh kosong</div>
            )}

            <TextField
              id="deskripsi"
              label="Deskripsi"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, deskripsi: e.target.value })
              }
              value={formData.deskripsi}
            />
            {alertDeskripsi && (
              <div className="danger-alert">Deskripsi tidak boleh kosong</div>
            )}

            <TextField
              id="link"
              label="Link"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, link: e.target.value })
              }
              value={formData.link}
            />
            {alertLink && (
              <div className="danger-alert">Link tidak boleh kosong</div>
            )}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  judul: "",
                  deskripsi: "",
                  link: "",
                });
                setAlertJudul(false);
                setAlertDeskripsi(false);
                setAlertLink(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i
            className={
              success
                ? "fas fa-check-circle pop-up-logo"
                : "fas fa-times-circle pop-up-logo failed-pop-up"
            }
          ></i>
          {success ? (
            <p>Berhasil</p>
          ) : (
            <p className={success ? "" : "failed-pop-up"}>Gagal</p>
          )}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertJudul(false);
              setAlertDeskripsi(false);
              setAlertLink(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaDokumenPerencanaan;
